module.exports = __webpack_public_path__ + "img/Tolaji Bola.77886a8b.png";